<template>
  <ul class="nav nav-tabs">
    <li
      v-for="(tab, index) in tabs"
      :key="index"
      class="nav-item"
    >
      <a
        class="nav-link"
        :class="{'active': index == currentTab}"
        href="#"
        @click.prevent="onSelect(index)"
      >
        <slot :tab="tab">{{ tab }}</slot>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
    name: 'BaseTabs',
    props: {
        currentTab: {
            type: Number,
            required: true,
        },
        tabs: {
            type: Array,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onSelect(index) {
            if (this.disabled) {
                return;
            }
            this.$emit('change-current-tab', index);
        },
    },
};
</script>
